import React from "react";

import {Steps} from "antd";
import PropTypes from "prop-types";

import "./styles.scss";
import {useTranslation} from "react-i18next";
import {NAME_SPACES} from "../../locals/constants";

const {Step} = Steps;

const Stepper = ({data, activeStep}) => {
	const {t} = useTranslation(NAME_SPACES.NEW_FOLDER, {
		keyPrefix: "STEPS",
	});

	return (
			<div className={"stepper--wrapper"}>
				<Steps
						progressDot
						current={activeStep}
						size={"default"}
						className="stepper--wrapper--items">
					{data.map(({key, text, i18n}) => (
							<Step title={t(i18n, text)} key={`step:${key}`} />
					))}
				</Steps>
			</div>
	);
};

Stepper.propTypes = {
	data: PropTypes.arrayOf(
			PropTypes.shape({
				                text: PropTypes.string,
			                }),
	),
	activeStep: PropTypes.number,
};

Stepper.defaultProps = {};

export default Stepper;
